const waitForElement = (
  elementFinder: () => HTMLElement | null | undefined,
  timeout = 1000,
  interval = 10
): Promise<HTMLElement> =>
  new Promise((resolve, reject) => {
    let timeoutRef = null;
    const intervalRef = setInterval(() => {
      const element = elementFinder();

      if (element) {
        if (timeoutRef !== null) {
          clearTimeout(timeoutRef);
        }

        clearInterval(intervalRef);
        resolve(element);
      }
    }, interval);
    timeoutRef = setTimeout(() => {
      clearInterval(intervalRef);
      reject();
    }, timeout);
  });

export default waitForElement;
